var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("RecommendList"),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("SelectGenre"),
      _vm._v(" "),
      _c("MenuList")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h2",
      { staticClass: "p-hdg-weng _mt0", attrs: { id: "recommend" } },
      [
        _vm._v("おすすめメニュー"),
        _c("span", { staticClass: "en" }, [_vm._v("RECOMMENDED MENU")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "p-hdg-weng", attrs: { id: "menulist" } }, [
      _vm._v("メニュー一覧"),
      _c("span", { staticClass: "en" }, [_vm._v("MENU LIST")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }